module.exports = __webpack_public_path__ + "img/hj-bg2.80d9448e.jpg";